import React from 'react';
import Navbar from '../Nav';
import Hero from '../Parts/Hero';
import Services from '../Parts/Services';
import AboutUs from '../Parts/AboutUs';
import Clients from '../Parts/Clients';
import WhyUs from '../Parts/WhyUs';
import OurTeam from '../Parts/OurTeam';
import ContactToday from '../Parts/ContactToday';
import Footer from '../Footer';
function Homepage() {
  return (
    <>
      <Navbar />
      <Hero
        videoSrc="/images/video1.mp4"
        />
      <Services />
      <AboutUs />
      <Clients />
      <WhyUs />
      <OurTeam />   
      <ContactToday />
      <Footer />
    </>
  );
}

export default Homepage;